import { updateHash } from "../../utils/urlHash";
import { allTime, dateSelectionHash } from "./dateSelection";
import { LOCAL_ACTIVITY_SEARCH } from "./activityScope";

/** The signed-in user's active sessions awaiting analysis, across all dates. */
export const unanalyzedSessionsHref = (userId: string) => ({
  pathname: "/recordings/",
  search: LOCAL_ACTIVITY_SEARCH,
  hash: updateHash("", {
    ru: userId,
    rstatus: "not_analyzed",
    ...dateSelectionHash(allTime),
  }),
});
